import React from 'react';

export const PiramidLogoSVG = (props: { size?: number }) => {
  const size = props.size ?? 24;
  return (
    <svg
      width={props.size}
      height={props.size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='inline-block'
    >
      <rect width={size} height={size} fill='white' fillOpacity='0.01' />
      <path d='M24 4L42 35L24 44V4Z' fill='#FC762D' />

      <path
        d='M24 44L42 35L24 4L6 35L24 44Z'
        stroke='#FC762D'
        stroke-width='4'
        stroke-linecap='round'
        stroke-linejoin='round'
      />

      <path
        d='M24 44V4'
        stroke='FC762D'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};

export const AutoinspectorLogoSVG = (props: { size?: number }) => {
  const size = props.size ?? 24;
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 149 181'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16 84V65C16 32 42 12 80 12H94C116 12 128 27 128 49C128 72 112 84 82 84H16Z'
        fill='#B59AF2'
      />

      <path
        d='M135 101V121C135 156 108 181 66 181H58C28 181 10 164 10 138C10 115 27 101 58 101H135Z'
        fill='#8657F2'
      />
    </svg>
  );
};

export const KachLogoSVG = (props: { size?: number }) => {
  const size = props.size ?? 24;
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 128 128'
      fill='none'
      className='rounded-xs'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='128' height='128' fill='#4E5E74' />
      <rect x='46' y='16' width='9' height='95' fill='white' />

      <path
        d='M69 48H78V70C78 75 76 79 71 82C76 85 78 89 78 94V111H69V82H60V74H69V48Z'
        fill='white'
      />
    </svg>
  );
};
